exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading{display:table;vertical-align:middle;height:100%;width:100%;font-size:18px;opacity:0.8}.loading i:first-child{margin-right:12px;vertical-align:middle;font-size:28px;display:inline-block}.loading .loading__inner{display:table-cell;vertical-align:middle;text-align:center;padding-left:20px;padding-right:20px;overflow:hidden}.loading .loading__inner code{margin:20px;padding:15px;font-size:13px;display:block;background:#fff;width:80%;max-height:300px;overflow:auto;word-wrap:break-word;text-align:left}.loading .loading__inner .pro-tip{font-size:14px;margin-top:30px}.loading .loading__msg{padding-top:10px}\n", ""]);

// exports
